import { initializer as observationInitializer } from '../observation/observation';
import { initializer as modelingInitializer } from '../modeling/modeling';
import { initializer as poiInitializer } from '../poi/poi';
import { authenticator as observationAuthenticator } from '../observation/observation';
import { authenticator as modelingAuthenticator } from '../modeling/modeling';
import { authenticator as poiAuthenticator } from '../poi/poi';
import { Application } from './application';

export const initialize = ( moduleNames : string[], application: Application ) : void => {
    let initializers = Object.assign({},observationInitializer,modelingInitializer);//, poiInitializer);
    
    moduleNames
    .filter(moduleName => initializers[ moduleName ] !== undefined )
    .forEach( moduleName => initializers[ moduleName ]( application ) ); 
  
}

export const authenticate = ( moduleNames : string[]) : void => {
    let authenticators = Object.assign({},observationAuthenticator,modelingAuthenticator);//, poiAuthenticator);
    
    moduleNames
    .filter(moduleName => authenticators[ moduleName ] !== undefined )
    .forEach( moduleName => authenticators[ moduleName ]( ) ); 
  
}